// src/components/no-matches-found/no-matches-found.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment CarRentalLocationFragment on CarRentalLocation {\n    airportCode\n    coordinates {\n      latitude\n      longitude\n    }\n    isExactLocationSearch\n    regionId\n    searchTerm\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment DateTimeFragment on DateTime {\n    day\n    month\n    year\n    hour\n    minute\n    second\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    disabled\n    name\n    primary\n    value\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    accessibility\n    disabled\n    icon {\n      ...EGDSGraphicFragment\n    }\n    name\n    primary\n    remove {\n      ...EGDSGraphicFragment\n    }\n    removeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    selected\n    value\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSPillFragment on EGDSPill {\n    ...EGDSBasicPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment ActivityBasicShoppingAppliedFilterFragment on BasicShoppingAppliedFilter {\n    filter {\n      ...EGDSPillFragment\n    }\n    nextSearchCriteria {\n      selections {\n        id\n        value\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment ActivityShoppingAppliedFilterFragment on ShoppingAppliedFilter {\n    ...ActivityBasicShoppingAppliedFilterFragment\n  }\n\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n    headingType\n    accessibility\n  }\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconTextFragment on EGDSIconText {\n    icon {\n      ...EGDSIconFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    size\n    text\n  }\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    accessibility\n    decorative\n  }\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSIconTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSParagraphFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonActionFragment on UIAction {\n    analytics {\n      linkName\n      referrerId\n    }\n\n    ... on ActivityOpenOffersModalAction {\n      activityId\n      dateRange {\n        startDate {\n          day\n          month\n          year\n        }\n        endDate {\n          day\n          month\n          year\n        }\n      }\n      dismissButtonAccessibility\n      dismissButtonAnalytics {\n        linkName\n        referrerId\n      }\n      selectedOffers {\n        offerProductNaturalKey\n      }\n      heading {\n        ...EGDSHeadingFragment\n      }\n      subHeading {\n        ...EGDSPlainTextFragment\n      }\n    }\n\n    ... on ActivityAddOfferToTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      offerNaturalKey {\n        offerProductNaturalKey\n      }\n    }\n\n    ... on ActivityRemoveOffersFromTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      offerNaturalKeys {\n        offerProductNaturalKey\n      }\n    }\n\n    ... on ActivityUpdateOfferInTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      newOfferNaturalKey {\n        offerProductNaturalKey\n      }\n      oldOfferNaturalKey {\n        offerProductNaturalKey\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    accessibility\n    disabled\n    action {\n      ...EGDSButtonActionFragment\n    }\n    icon {\n      description\n      id\n      title\n    }\n  }\n\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment NoMatchesFoundComponentFragment on NoMatchesFoundComponent {\n    title\n    message\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    filterPills {\n      ...ActivityShoppingAppliedFilterFragment\n    }\n    removeAllFiltersButton {\n      ...EGDSButtonFragment\n    }\n    removeAllFiltersAction {\n      ... on ActivityLinkClickAction {\n        linkTagUrl\n        clientSideAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
import React21, { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { gql as gql26 } from "@apollo/client";
// ../internal/src/__fragments/common/date-fragment.ts
import { gql } from "@apollo/client";
var __DateFragment = gql(_templateObject());
// ../internal/src/__fragments/common/client-side-analytics.ts
import { gql as gql2 } from "@apollo/client";
var clientSideAnalyticsFragment = gql2(_templateObject1());
// ../internal/src/__fragments/common/car-rental-location.ts
import { gql as gql3 } from "@apollo/client";
var __CarRentalLocation = gql3(_templateObject2());
// ../internal/src/__fragments/common/date-time.ts
import { gql as gql4 } from "@apollo/client";
var __DateTime = gql4(_templateObject3());
// ../internal/src/components/activity-shopping-applied-filter/activity-shopping-applied-filter.tsx
import React8 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/activity-shopping-applied-filter/__fragments/activity-basic-shopping-applied-filter.tsx
import React7 from "react";
import { gql as gql11 } from "@apollo/client";
// ../internal/src/components/egds-pill/egds-pill.tsx
import React6 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/egds-pill/egds-basic-pill.tsx
import React from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkPill } from "uitk-react-pill";
var __Fragment = gql5(_templateObject4());
var EGDSBasicPill = function (param) {
  var className = param.className,
    onChange = param.onChange,
    data = param.data;
  var accessibility = data.accessibility,
    disabled = data.disabled,
    name = data.name,
    primary = data.primary,
    value = data.value;
  var _React_useState = _sliced_to_array(React.useState(false), 2),
    isChecked = _React_useState[0],
    setIsChecked = _React_useState[1];
  var handleOnChange = React.useCallback(function (event) {
    setIsChecked(!isChecked);
    if (onChange) {
      onChange(event);
    }
  }, [isChecked, onChange]);
  if (!name || !primary || !value) {
    return null;
  }
  return /* @__PURE__ */React.createElement(UitkPill, {
    id: "activity-pill-".concat(name, "-").concat(value),
    altText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    className: className,
    checked: isChecked,
    disabled: disabled,
    name: name,
    onChange: handleOnChange,
    value: value
  }, primary);
};
EGDSBasicPill.fragment = __Fragment;
EGDSBasicPill.displayName = "EGDSBasicPill";
// ../internal/src/components/egds-pill/egds-basic-removable-pill.tsx
import React5 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql8 } from "@apollo/client";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React2 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __EGDSIconFragment = gql6(_templateObject5());
var _data_title, _data_theme;
var EGDSIcon = function (param) {
  var className = param.className,
    data = param.data;
  var _data;
  return /* @__PURE__ */React2.createElement(UitkIcon, {
    className: className,
    description: data.description,
    id: Math.random().toString(),
    name: data.id,
    size: data.size ? UitkIconSize[data.size] : void 0,
    title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: (_data_theme = (_data = data) === null || _data === void 0 ? void 0 : _data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
    shadow: Boolean(data.withBackground)
  });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React3 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var __EGDSMarkFragment = gql7(_templateObject6());
var EGDSMark = function (param) {
  var className = param.className,
    data = param.data;
  var _data_url;
  return /* @__PURE__ */React3.createElement(UitkMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? UitkMarkSize[data.markSize] : void 0,
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
var __EGDSGraphicFragment = gql8(_templateObject7(), EGDSIcon.fragment, EGDSMark.fragment);
var EGDSGraphic = function (param) {
  var className = param.className,
    data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React4.createElement(EGDSIcon, {
        className: className,
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React4.createElement(EGDSMark, {
        className: className,
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-pill/egds-basic-removable-pill.tsx
var fragment = gql9(_templateObject8(), EGDSGraphic.fragment, clientSideAnalyticsFragment);
var EGDSBasicRemovablePill = function (param) {
  var data = param.data,
    onClickCallback = param.onClickCallback;
  var _icon;
  var trackClick = useClickTracker();
  var accessibility = data.accessibility,
    disabled = data.disabled,
    icon = data.icon,
    primary = data.primary,
    removeAnalytics = data.removeAnalytics,
    value = data.value;
  var clickHandle = React5.useCallback(function () {
    if (removeAnalytics) {
      trackClick(removeAnalytics.referrerId, removeAnalytics.linkName);
    }
    if (onClickCallback) {
      onClickCallback();
    }
  }, [onClickCallback]);
  if (!primary || !value) {
    return null;
  }
  return /* @__PURE__ */React5.createElement(UitkRemovablePill, {
    id: value || "pill",
    disabled: disabled,
    onClick: clickHandle,
    altText: accessibility || void 0,
    value: value || void 0,
    icon: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.__typename) === "Icon" ? icon.id : void 0
  }, primary);
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = fragment;
// ../internal/src/components/egds-pill/egds-pill.tsx
var __Fragment2 = gql10(_templateObject9(), EGDSBasicPill.fragment, EGDSBasicRemovablePill.fragment);
var EGDSPill = function (param) {
  var className = param.className,
    onChange = param.onChange,
    onClickCallback = param.onClickCallback,
    data = param.data;
  switch (data.__typename) {
    case "EGDSBasicPill":
      return /* @__PURE__ */React6.createElement(EGDSBasicPill, {
        className: className,
        onChange: onChange,
        data: data
      });
    case "EGDSBasicRemovablePill":
      return /* @__PURE__ */React6.createElement(EGDSBasicRemovablePill, {
        data: data,
        onClickCallback: onClickCallback
      });
    default:
      return null;
  }
};
EGDSPill.fragment = __Fragment2;
EGDSPill.displayName = "EGDSPill";
// ../internal/src/components/activity-shopping-applied-filter/__fragments/activity-basic-shopping-applied-filter.tsx
var fragment2 = gql11(_templateObject10(), EGDSPill.fragment);
var ActivityBasicShoppingAppliedFilter = function (param) {
  var data = param.data,
    onRemovePill = param.onRemovePill;
  var filter = data.filter;
  var onClickHandler = function () {
    var _onRemovePill;
    (_onRemovePill = onRemovePill) === null || _onRemovePill === void 0 ? void 0 : _onRemovePill(data);
  };
  if (!filter) {
    return null;
  }
  return /* @__PURE__ */React7.createElement(EGDSPill, {
    data: filter,
    onClickCallback: onClickHandler
  });
};
ActivityBasicShoppingAppliedFilter.fragment = fragment2;
ActivityBasicShoppingAppliedFilter.displayName = "ActivityBasicShoppingAppliedFilter";
// ../internal/src/components/activity-shopping-applied-filter/activity-shopping-applied-filter.tsx
var fragment3 = gql12(_templateObject11(), ActivityBasicShoppingAppliedFilter.fragment);
var ActivityShoppingAppliedFilter = function (param) {
  var data = param.data,
    onRemovePill = param.onRemovePill;
  switch (data.__typename) {
    case "BasicShoppingAppliedFilter":
      return /* @__PURE__ */React8.createElement(ActivityBasicShoppingAppliedFilter, {
        data: data,
        onRemovePill: onRemovePill
      });
    default:
      return null;
  }
};
ActivityShoppingAppliedFilter.fragment = fragment3;
ActivityShoppingAppliedFilter.displayName = "ActivityShoppingAppliedFilter";
// ../internal/src/components/egds-button/egds-button.tsx
import React20 from "react";
import { gql as gql25 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkOverlayButton, UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
// ../internal/src/components/egds-button/egds-button-action.ts
import { gql as gql24 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-heading.tsx
import React9 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var _obj;
// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = (_obj = {}, _define_property(_obj, "H1" /* H1 */, "h1"), _define_property(_obj, "H2" /* H2 */, "h2"), _define_property(_obj, "H3" /* H3 */, "h3"), _define_property(_obj, "H4" /* H4 */, "h4"), _define_property(_obj, "H5" /* H5 */, "h5"), _define_property(_obj, "H6" /* H6 */, "h6"), _define_property(_obj, "H7" /* H7 */, "h6"), _define_property(_obj, "H8" /* H8 */, "h6"), _obj);
// ../internal/src/components/egds-text/egds-heading.tsx
var fragment4 = gql13(_templateObject12());
var EGDSHeading = function (param) {
  var className = param.className,
    align = param.align,
    size = param.size,
    tag = param.tag,
    data = param.data,
    tabIndex = param.tabIndex;
  var headingType = data.headingType,
    text = data.text,
    accessibility = data.accessibility;
  var headingTag = tag !== null && tag !== void 0 ? tag : headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React9.createElement(React9.Fragment, null, /* @__PURE__ */React9.createElement(UitkHeading, {
    className: className,
    align: align,
    tag: tag !== null && tag !== void 0 ? tag : headingTag,
    size: size,
    tabIndex: tabIndex,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React9.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSHeading.fragment = fragment4;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React10 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var _obj1;
// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = (_obj1 = {}, _define_property(_obj1, "P1" /* P1 */, 1), _define_property(_obj1, "P2" /* P2 */, 2), _define_property(_obj1, "P3" /* P3 */, 3), _obj1);
// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment5 = gql14(_templateObject13());
var EGDSParagraph = function (param) {
  var className = param.className,
    data = param.data;
  var text = data.text,
    style = data.style;
  return /* @__PURE__ */React10.createElement(UitkParagraph, {
    className: className,
    size: paragraphStyleSizeMap[style]
  }, text);
};
EGDSParagraph.fragment = fragment5;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React11 from "react";
import { gql as gql15 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
var _obj2;
// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = (_obj2 = {}, _define_property(_obj2, "SMALL" /* SMALL */, "small"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "LARGE" /* LARGE */, "large"), _obj2);
var _obj3;
var UILinkTargetMap = (_obj3 = {}, _define_property(_obj3, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj3, "INTERNAL" /* INTERNAL */, "_self"), _obj3);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment6 = gql15(_templateObject14(), EGDSIcon.fragment);
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React11.createElement(EGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    useRelativePath = _param_data_action.useRelativePath,
    disabled = _param_data.disabled,
    iconPosition = _param_data.iconPosition,
    standardLinkIcon = _param_data.standardLinkIcon,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker2();
  var onClick = React11.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  var getPath = React11.useCallback(function () {
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  }, [resource, useRelativePath]);
  return /* @__PURE__ */React11.createElement(UitkLink, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline,
    disabled: disabled,
    align: align
  }, /* @__PURE__ */React11.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React11.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React11.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React11.createElement(UitkText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment6;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-text.tsx
import React19 from "react";
import { gql as gql23 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React12 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment7 = gql16(_templateObject15(), EGDSGraphic.fragment);
var graphicMargin = {
  inlineend: "one"
};
var textMargin = {
  inlineend: "one"
};
var EGDSGraphicText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var graphic = data.graphic,
    text = data.text;
  return /* @__PURE__ */React12.createElement(UitkLayoutFlex, {
    className: className
  }, /* @__PURE__ */React12.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React12.createElement(UitkSpacing, {
    margin: graphicMargin
  }, /* @__PURE__ */React12.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React12.createElement(UitkLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React12.createElement(UitkSpacing, {
    margin: textMargin
  }, /* @__PURE__ */React12.createElement(UitkText2, {
    size: size
  }, text))));
};
EGDSGraphicText.fragment = fragment7;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-text/egds-icon-text.tsx
import React13 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment8 = gql17(_templateObject16(), EGDSIcon.fragment);
var iconMargin = {
  inlineend: "one"
};
var textMargin2 = {
  inlineend: "one"
};
var EGDSIconText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var icon = data.icon,
    text = data.text;
  return /* @__PURE__ */React13.createElement(UitkLayoutFlex2, {
    className: className
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React13.createElement(UitkSpacing2, {
    margin: iconMargin
  }, /* @__PURE__ */React13.createElement(EGDSIcon, {
    data: icon
  }))), /* @__PURE__ */React13.createElement(UitkLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React13.createElement(UitkSpacing2, {
    margin: textMargin2
  }, /* @__PURE__ */React13.createElement(UitkText3, {
    size: size
  }, text))));
};
EGDSIconText.fragment = fragment8;
EGDSIconText.displayName = "EGDSIconText";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React14 from "react";
import { gql as gql18 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment9 = gql18(_templateObject17());
var EGDSInlineLink = function (param) {
  var className = param.className,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    disabled = _param_data.disabled,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker3();
  var onClick = React14.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React14.createElement(UitkLink2, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    disabled: disabled,
    inline: true
  }, /* @__PURE__ */React14.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React14.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment9;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React15 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment10 = gql19(_templateObject18());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    theme = param.theme,
    data = param.data;
  var text = data.text;
  return /* @__PURE__ */React15.createElement(UitkText4, {
    whiteSpace: "pre-line",
    className: className,
    align: align,
    size: size,
    inline: inline,
    theme: theme
  }, text);
};
EGDSPlainText.fragment = fragment10;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React18 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkText as UitkText6 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React17 from "react";
import { gql as gql21 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React16 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
var _obj4;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj4 = {}, _define_property(_obj4, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj4, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj4, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj4, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj4, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj4, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj4, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj4, "EMPHASIS" /* EMPHASIS */, "emphasis"), _obj4);
var _obj5;
var UitkTextThemeMapper = (_obj5 = {}, _define_property(_obj5, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj5, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj5, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj5, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj5, "DEFAULT" /* DEFAULT */, "default"), _obj5);
var _obj6;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj6 = {}, _define_property(_obj6, "BOLD" /* BOLD */, "bold"), _define_property(_obj6, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj6, "REGULAR" /* REGULAR */, "regular"), _obj6);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment11 = gql20(_templateObject19());
var EGDSStylizedText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    data = param.data;
  var text = data.text,
    theme = data.theme,
    weight = data.weight,
    accessibility = data.accessibility,
    decorative = data.decorative;
  var themeProps = theme ? textThemeMapper[theme] : void 0;
  var weightProps = weight ? textWeightMapper[weight] : void 0;
  var RenderText = function () {
    return /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(UitkText5, {
      className: className,
      align: align,
      inline: inline,
      size: size,
      theme: themeProps,
      weight: weightProps,
      "aria-hidden": accessibility !== null
    }, text), accessibility && /* @__PURE__ */React16.createElement("span", {
      className: "is-visually-hidden"
    }, accessibility));
  };
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      return /* @__PURE__ */React16.createElement("s", null, /* @__PURE__ */React16.createElement(RenderText, null));
    default:
      return /* @__PURE__ */React16.createElement(RenderText, null);
  }
};
EGDSStylizedText.fragment = fragment11;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment12 = gql21(_templateObject20(), EGDSStylizedText.fragment, EGDSGraphicText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    align = param.align,
    theme = param.theme,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React17.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: true
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React17.createElement(EGDSGraphicText, {
        className: className,
        data: data,
        size: size
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React17.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        align: align,
        inline: true,
        theme: theme
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment12;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment13 = gql22(_templateObject21(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_contents, _data, _data_inlineContent, _data1, _data_inlineContent1, _data2;
  var align = props.align,
    headingSize = props.headingSize,
    data = props.data,
    theme = props.theme,
    styleProps = _object_without_properties(props, ["align", "headingSize", "data", "theme"]);
  if (((_data = data) === null || _data === void 0 ? void 0 : (_data_contents = _data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_inlineContent = _data1.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
    return /* @__PURE__ */React18.createElement(UitkText6, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align,
      theme: theme
    }), data.text);
  }
  if ((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_inlineContent1 = _data2.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
    return /* @__PURE__ */React18.createElement(React18.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React18.createElement(React18.Fragment, null, /* @__PURE__ */React18.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        align: align,
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index),
        theme: theme
      })), " ");
    }));
  }
  return /* @__PURE__ */React18.createElement(React18.Fragment, null, data.contents.map(function (item, index) {
    return /* @__PURE__ */React18.createElement(React18.Fragment, {
      key: "spannable-item-".concat(index)
    }, /* @__PURE__ */React18.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
      data: item
    }, styleProps), {
      headingSize: headingSize,
      theme: theme
    })), " ");
  }));
};
EGDSSpannableText.fragment = fragment13;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment14 = gql23(_templateObject22(), EGDSHeading.fragment, EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSIconText.fragment, EGDSGraphicText.fragment, EGDSParagraph.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment, EGDSSpannableText.fragment);
var EGDSText = function (param) {
  var className = param.className,
    headingAlign = param.headingAlign,
    headingSize = param.headingSize,
    headingTag = param.headingTag,
    textAlign = param.textAlign,
    textSize = param.textSize,
    align = param.align,
    inline = param.inline,
    tabIndex = param.tabIndex,
    theme = param.theme,
    data = param.data;
  var _data;
  switch ((_data = data) === null || _data === void 0 ? void 0 : _data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React19.createElement(EGDSHeading, {
        className: className,
        align: headingAlign,
        size: headingSize,
        tag: headingTag,
        data: data,
        tabIndex: tabIndex
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React19.createElement(EGDSPlainText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline,
        theme: theme
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React19.createElement(EGDSStylizedText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React19.createElement(EGDSGraphicText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSIconText":
      return /* @__PURE__ */React19.createElement(EGDSIconText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React19.createElement(EGDSParagraph, {
        className: className,
        data: data
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React19.createElement(EGDSStandardLink, {
        className: className,
        data: data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React19.createElement(EGDSInlineLink, {
        className: className,
        data: data
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React19.createElement(EGDSSpannableText, {
        className: className,
        size: textSize,
        headingSize: headingSize,
        data: data,
        align: align,
        theme: theme
      });
    default:
      return null;
  }
};
EGDSText.fragment = fragment14;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/egds-button/egds-button-action.ts
var __EGDSButtonActionFragment = gql24(_templateObject23(), EGDSHeading.fragment, EGDSPlainText.fragment);
// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql25(_templateObject24(), __EGDSButtonActionFragment);
var EGDSButton = function (param) {
  var analytics = param.analytics,
    className = param.className,
    domRef = param.domRef,
    href = param.href,
    isFullWidth = param.isFullWidth,
    onClickHandler = param.onClickHandler,
    size = param.size,
    data = param.data;
  var __typename = data.__typename,
    accessibility = data.accessibility,
    action = data.action,
    primary = data.primary,
    disabled = data.disabled,
    icon = data.icon;
  var clickTracker = useClickTracker4();
  var analyticsButton = action ? {
    description: action.analytics.linkName,
    id: action.analytics.referrerId,
    callback: function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }
  } : void 0;
  var handleOnClick = React20.useCallback(function () {
    var _onClickHandler;
    (_onClickHandler = onClickHandler) === null || _onClickHandler === void 0 ? void 0 : _onClickHandler();
  }, [onClickHandler]);
  if (!primary) {
    return null;
  }
  var buttonProps = {
    analytics: analytics || analyticsButton,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    className: className,
    disabled: disabled,
    href: href,
    isFullWidth: isFullWidth,
    onClick: handleOnClick,
    size: size,
    domRef: domRef
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React20.createElement(UitkPrimaryButton, _object_spread({}, buttonProps), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React20.createElement(UitkSecondaryButton, _object_spread({}, buttonProps), primary);
    case "UITertiaryButton":
      return /* @__PURE__ */React20.createElement(UitkTertiaryButton, _object_spread({}, buttonProps), primary);
    case "EGDSOverlayButton":
      var _icon;
      var _icon_id;
      return /* @__PURE__ */React20.createElement(UitkOverlayButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */React20.createElement(UitkIcon2, {
        name: (_icon_id = (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) !== null && _icon_id !== void 0 ? _icon_id : ""
      }), primary);
    default:
      return null;
  }
};
EGDSButton.fragment = _Fragment;
EGDSButton.displayName = "EGDSButton";
// src/components/no-matches-found/no-matches-found.tsx
import { IntersectionTracker, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkPillContainer } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText7 } from "uitk-react-text";
var SLIM_SEARCH_KEYWORD_QUERY_PARAM = "slimSearchKeyword";
var FILTER_URL_PARAM_PREFIX = "filter.";
var __NoMatchesFoundComponentFragment = gql26(_templateObject25(), EGDSGraphic.fragment, ActivityShoppingAppliedFilter.fragment, EGDSButton.fragment, clientSideAnalyticsFragment);
var NoMatchesFound = function (param) {
  var data = param.data;
  var _filterPills;
  var trackClick = useClickTracker5();
  var location = useLocation();
  var history = useHistory();
  var searchParams = useMemo(function () {
    return new URLSearchParams(location.search);
  }, [location.search]);
  var removeAllFiltersAction = data.removeAllFiltersAction;
  var handleRemoveAllFiltersOnClick = useCallback(function () {
    var _removeAllFiltersAction, _removeAllFiltersAction1;
    if ((_removeAllFiltersAction = removeAllFiltersAction) === null || _removeAllFiltersAction === void 0 ? void 0 : _removeAllFiltersAction.clientSideAnalytics) {
      trackClick(removeAllFiltersAction.clientSideAnalytics.referrerId, removeAllFiltersAction.clientSideAnalytics.linkName);
    }
    var relativeUrl = (_removeAllFiltersAction1 = removeAllFiltersAction) === null || _removeAllFiltersAction1 === void 0 ? void 0 : _removeAllFiltersAction1.linkTagUrl;
    if (relativeUrl) {
      var searchParamsString = "?".concat(relativeUrl.split("?")[1]);
      var urlSearchParams = new URLSearchParams(searchParamsString);
      history.replace({
        pathname: location.pathname,
        hash: location.hash,
        state: location.state,
        search: urlSearchParams.toString()
      });
    }
  }, [removeAllFiltersAction, trackClick, location, history]);
  var onRemovePill = useCallback(function (appliedFilter) {
    if (appliedFilter.__typename === "BasicShoppingAppliedFilter") {
      var _appliedFilter_nextSearchCriteria;
      var selections = ((_appliedFilter_nextSearchCriteria = appliedFilter.nextSearchCriteria) === null || _appliedFilter_nextSearchCriteria === void 0 ? void 0 : _appliedFilter_nextSearchCriteria.selections) || [];
      if (selections.length > 0) {
        var filterCategory = selections[0].id;
        if (filterCategory === SLIM_SEARCH_KEYWORD_QUERY_PARAM) {
          var slimSearchKeyword = searchParams.get(SLIM_SEARCH_KEYWORD_QUERY_PARAM) || "";
          if (selections[0].value === slimSearchKeyword) {
            searchParams.delete(SLIM_SEARCH_KEYWORD_QUERY_PARAM);
            history.replace({
              pathname: location.pathname,
              hash: location.hash,
              state: location.state,
              search: searchParams.toString()
            });
          }
        } else {
          var filterCategoryKey = FILTER_URL_PARAM_PREFIX + filterCategory;
          var oldFiltersString = searchParams.get(filterCategoryKey) || "";
          var filters = oldFiltersString.split(",").filter(function (filter) {
            return filter !== "";
          });
          selections.forEach(function (selection) {
            var indexOfFilterToDelete = filters.indexOf(selection.value);
            if (indexOfFilterToDelete > -1) {
              filters.splice(indexOfFilterToDelete, 1);
            }
          });
          var filtersString = filters.join(",");
          searchParams.set(filterCategoryKey, filtersString);
          history.replace({
            pathname: location.pathname,
            hash: location.hash,
            state: location.state,
            search: searchParams.toString()
          });
        }
      }
    }
  }, [searchParams, location, history]);
  var title = data.title,
    message = data.message,
    graphic = data.graphic,
    filterPills = data.filterPills,
    removeAllFiltersButton = data.removeAllFiltersButton,
    analytics = data.analytics;
  var pills = (_filterPills = filterPills) === null || _filterPills === void 0 ? void 0 : _filterPills.map(function (filterPill, index) {
    return /* @__PURE__ */React21.createElement(ActivityShoppingAppliedFilter, {
      key: "filterPill".concat(index),
      data: filterPill,
      onRemovePill: onRemovePill
    });
  });
  var noMatchesFoundComponent = /* @__PURE__ */React21.createElement(UitkCard, {
    border: true
  }, /* @__PURE__ */React21.createElement(UitkSpacing3, {
    padding: {
      block: "twelve"
    }
  }, /* @__PURE__ */React21.createElement(UitkLayoutFlex3, {
    direction: "column",
    alignItems: "center"
  }, graphic && /* @__PURE__ */React21.createElement(EGDSGraphic, {
    data: graphic
  }), /* @__PURE__ */React21.createElement(UitkSpacing3, {
    margin: {
      blockstart: "six"
    },
    padding: {
      inline: "six"
    }
  }, /* @__PURE__ */React21.createElement(UitkHeading2, {
    size: 4,
    align: "center"
  }, title)), message && /* @__PURE__ */React21.createElement(UitkSpacing3, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React21.createElement(UitkText7, {
    size: 400
  }, message)), pills && /* @__PURE__ */React21.createElement(UitkSpacing3, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React21.createElement(UitkPillContainer, {
    wrap: true,
    align: "center"
  }, pills)), removeAllFiltersButton && /* @__PURE__ */React21.createElement(UitkSpacing3, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React21.createElement(EGDSButton, {
    data: removeAllFiltersButton,
    onClickHandler: handleRemoveAllFiltersOnClick
  })))));
  return /* @__PURE__ */React21.createElement(IntersectionTracker, {
    referrerId: analytics.referrerId,
    linkName: analytics.linkName
  }, noMatchesFoundComponent);
};
NoMatchesFound.fragment = __NoMatchesFoundComponentFragment;
NoMatchesFound.displayName = "sharedui-NoMatchesFound";
export { NoMatchesFound };